import { render, staticRenderFns } from "./loses-evaluation-auto.vue?vue&type=template&id=f1c127f6&scoped=true&"
import script from "./loses-evaluation-auto.vue?vue&type=script&lang=js&"
export * from "./loses-evaluation-auto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c127f6",
  null
  
)

export default component.exports